/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vp_LabelInputs */



/**
* | output |
* | --- |
* | "Victory points" |
*
* @param {Vp_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const vp_label = /** @type {((inputs?: Vp_LabelInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vp_LabelInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Points de victoire")
	if (locale === "es") return /** @type {LocalizedString} */ ("Puntos de victoria")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Pontos de vitória")
	if (locale === "it") return /** @type {LocalizedString} */ ("Victory points")
	return /** @type {LocalizedString} */ ("Victory points")
});